<template>
  <transition-group class="ag-notification-container" name="fade" tag="ul">
    <li v-for="notification in notifications" :key="notification.id" class="ag-notification-container__notification">
      <AGNotification
        :id="notification.id"
        :closable="notification.closable"
        :icon="notification.icon"
        :link-text="notification.linkText"
        :loading="notification.loading"
        :message="notification.message"
        :timeout="notification.timeout"
        :type="notification.type"
        @click:close="removeNotification(notification.id)"
        @click:link="notification.onClickLink()"
      />
    </li>
  </transition-group>
</template>

<script>
import AGNotification from '@/components/common/AGNotification.vue';
import { useStoreNotify } from '@/stores/StoreNotify';
import { mapActions, mapState } from 'pinia';

export default {
  components: { AGNotification },

  computed: {
    ...mapState(useStoreNotify, ['notifications']),
  },

  methods: {
    ...mapActions(useStoreNotify, ['removeNotification']),
  },
};
</script>

<style lang="scss" scoped>
.ag-notification-container {
  width: calc(100% - var(--v-layout-left, 0px));
  height: auto;
  padding: 0;

  position: fixed;
  top: calc(var(--v-layout-top, 50px) + 10px);
  z-index: 999999999;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  pointer-events: none;

  .ag-notification-container__notification {
    list-style-type: none;
    padding: 0;
  }
}

.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s cubic-bezier(0.55, 0, 0.1, 1);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-leave-active {
  position: absolute;
}
</style>
